module.exports = __webpack_public_path__ + "img/Group (6).e5ae6280.svg";